module.exports = __webpack_public_path__ + "img/bathrooms.4c939e6a.svg";